<template>
  <b-modal :title="`Select Account`" v-model="visible" size="lg" hide-footer>
    <b-row>
      <b-col cols="12">
        <b-form-group>
          <b-form-input type="text" id="search" placeholder="Search for Account..." v-model="query" autocomplete="off"></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <loading :isLoading="searching" :items="results" noItemsText="No Results"></loading>
        <b-list-group>
          <b-list-group-item v-for="item in results" v-bind:key="item.id" button @click="selectAccount(item.id)">
            <b-row>
              <b-col cols="8">
                {{ item.name }}
              </b-col>
              <b-col cols="4" class="text-right">
                <account-type :type="item.type"></account-type>
              </b-col>
            </b-row>
          </b-list-group-item>
        </b-list-group>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import AccountType from '@/components/badges/AccountType'
import Loading from '@/components/text/Loading'

export default {
  components: {
    AccountType,
    Loading
  },
  computed: {
    ...mapGetters({
      account: 'global/account'
    }),
    getBadge (status) {
      return status === 'business' ? 'success'
        : status === 'residential' ? 'primary': 'secondary'
    },
  },
  data () {
    return {
      visible: false,
      query: '',
      timer: null,
      searching: false,
      results: [],
      fields: [
        {key: 'name'},
        {key: 'type'},
        {key: 'prefix'}
      ],
    }
  },
  methods: {
    selectAccount (id) {
      this.$store.dispatch('global/setAccount', id)
      this.$router.push({ path: '/dashboard' })
      this.hide()
    },
    search () {
      if (this.timer) clearTimeout(this.timer)
      this.searching = true
      this.results = []
      this.timer = setTimeout(async  () => {
        const { data } = await this.$axios.get(`/v1/accounts?search=${this.query}`)
        this.results = data
        this.searching = false
      }, 500)
    },
    show () {
      this.query = ''
      this.visible = true
    },
    hide () {
      this.visible = false
    }
  },
  mounted () {
    this.$bus.$on('modal:selectAccount', () => {
      this.show();
    })
  },
  beforeDestroy () {
    this.$bus.$off('modal:selectAccount')
  },
  watch: {
    query () {
      this.search()
    }
  }
}
</script>
